"use client";

import { useSearchParams } from "next/navigation";
import { useBlogPushQuery } from "@/utils/functions/useBlogPushQuery";
import { DropdownButton, DropdownItem, Row } from "@/utils/bootstrap";
import SortDropdownTitle from "@/app/components/lib/sort-dropdown/SortDropdownTitle";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

const BlogSortDropdown: React.FC = () => {
  const { pushQueryToRouter } = useBlogPushQuery();
  const company = useGetCompanyQuery();
  const searchParams = useSearchParams();

  const sortOptions = company?.data?.result?.sort_types.blogs ?? [];

  const currentSort = searchParams?.get("sort_by") ?? "newest";
  const currentLabel =
    sortOptions?.find((s) => s.key === currentSort)?.value ??
    sortOptions[0]?.value;

  if (!sortOptions.length) return;
  return (
    <div className="sort-dropdown" style={{ marginBottom: 24 }}>
      <DropdownButton
        variant="outline"
        onSelect={(e: string | null) => {
          if (e) {
            pushQueryToRouter([{ name: "sort_by", val: e }], true);
          }
        }}
        title={<SortDropdownTitle title={currentLabel} />}
      >
        {sortOptions.map((option) => (
          <DropdownItem
            active={option.key === currentSort}
            key={option.key}
            eventKey={option.key}
          >
            <Row className="m-0">{option.value}</Row>
          </DropdownItem>
        ))}
      </DropdownButton>
    </div>
  );
};

export default BlogSortDropdown;
